import { Component, Input } from '@angular/core';
import { LoChip } from 'lo-design-system';
import { AccountType } from '@brand-lolly/app/_models/brand-instagram-integration.model';

@Component({
	standalone: true,
	selector: 'meta-account-type-badge',
	imports: [LoChip],
	template: `
		@if (type) {
		<lo-chip>{{ label }}</lo-chip>
		}
	`
})
export class MetaAccountTypeBadgeComponent {
	@Input() type: AccountType | null = null;

	get label(): string {
		switch (this.type) {
			case 'BUSINESS':
				return 'Business';
			case 'CREATOR':
				return 'Creator';
			case 'MEDIA_CREATOR':
				return 'Media Creator';
			case 'PERSONAL':
				return 'Personal';
			default:
				return '';
		}
	}
}
